module.exports = __webpack_public_path__ + "static/media/10_MTA - New York City.cf357f26.jpg";